import { Button } from "./button"

export const Input = () => {
  return (
    <div className="relative z-20">
      <input type="text" className="sm:min-w-[400px] border border-[#4EBBD4] bg-transparent rounded-[15px] py-[20px] pl-[30px] pr-[120px] font-lato text-white" placeholder="info@gmail.com" />
      <Button classes={`text-base sm:text-xl font-semibold py-5 px-4 rounded-[15px] absolute right-2 top-1/2 -translate-y-1/2`} text={<img src="/arrow.svg"/>}/>
    </div>
  )
}
